import React from 'react'

import { OptionControlConfig, OptionType } from 'apps/aiTextImprover/lib/types'

import { Button } from '../Button/Button'
import { Input } from '../Input/Input'

import cm from './OptionsList.module.css'

interface OptionsListProps<OptionValue extends string> {
  options: Array<{ value: OptionValue; config: OptionControlConfig }>
  onOptionSelect: (option: { value: OptionValue; additionalValue?: string }) => void
}

export const OptionsList = <OptionValue extends string>({
  options,
  onOptionSelect,
}: OptionsListProps<OptionValue>) => {
  const onButtonClick = (value: OptionValue) => {
    onOptionSelect({
      value,
    })
  }

  const onInputSubmit = (value: OptionValue, text: string) => {
    onOptionSelect({
      value,
      additionalValue: text,
    })
  }

  return (
    <div className={cm.optionsList}>
      {options.map((option, index) => {
        if (option.config.type === OptionType.INPUT) {
          return (
            <Input
              onSubmit={(text) => onInputSubmit(option.value, text)}
              key={index}
              config={option.config}
            />
          )
        }

        return (
          <Button
            value={option.value}
            onClick={onButtonClick as (value: string) => void}
            key={index}
            config={option.config}
          />
        )
      })}
    </div>
  )
}
